import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { FranchiseProduct } from '../campaign.type';

// Exported so jwtService can hand it the token: BaseApi injects it through a
// per-instance interceptor, so an instance nobody registers sends none at all.
export const franchiseProductApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

interface FranchiseProductPage {
  data: FranchiseProduct[];
  metadata: { page?: number; size?: number; total: number };
}

// Fetched in one go, without paging: the endpoint returns the products a franchise
// has actually sold, which is a few hundred at most, and the picker filters them in
// place. It also supports a server-side search, worth switching to only if a
// franchise ever grows a catalogue too large to hold.
export const getFranchiseProductsApi = async (franchiseId: string) => {
  const response = await franchiseProductApi.api.get<FranchiseProductPage>(`api/v2/franchises/${franchiseId}/products`);
  return response.data.data;
};
